import React from "react";
import {
  DataTable,
  DataTableHead,
  DataTableRow,
  DataTableCell as DataTableCellBase,
  DataTableCol as DataTableColBase,
} from "@flixbus/honeycomb-react";

// React 19 forwardRef compatibility: cast to FC to satisfy JSX type constraints
const DataTableCell = DataTableCellBase as React.FC<any>;
const DataTableCol = DataTableColBase as React.FC<any>;
import { Icon, IconInfoSolid } from "@flixbus/honeycomb-icons-react";
import CalculationEmptyState from "../CalculationEmptyState/CalculationEmptyState.component";
import ResultCellContent from "./ResultCellContent/ResultCellContent.component";
import type { CalculationResultsTableProps } from "./CalculationResultsTable.types";
import styles from "./CalculationResultsTable.module.scss";

const CalculationResultsTable: React.FC<CalculationResultsTableProps> = ({
  monthColumns,
  rows,
}) => {
  if (rows.length === 0) {
    return <CalculationEmptyState />;
  }

  return (
    <div className={styles.container}>
      <DataTable
        caption="Calculation results per month"
        extraClasses={styles.table}
        columns={
          <>
            <DataTableCol extraClasses={styles.labelCol} />
            {monthColumns.map((month) => (
              <DataTableCol key={month} />
            ))}
            <DataTableCol extraClasses={styles.totalCol} />
          </>
        }
        headers={
          <DataTableHead>
            <DataTableCell scope="col" extraClasses={styles.labelCell} />
            {monthColumns.map((month) => (
              <DataTableCell key={month} scope="col" align="center">
                {month}
              </DataTableCell>
            ))}
            <DataTableCell scope="col" align="center" divider="left">
              Total
            </DataTableCell>
          </DataTableHead>
        }
      >
        {rows.map((row, index) => (
          <DataTableRow
            key={index}
            extraClasses={row.isHighlighted ? styles.highlightedRow : undefined}
          >
            <DataTableCell scope="row" extraClasses={styles.labelCell}>
              <span className={styles.rowLabel}>
                {row.label}
                {row.isHighlighted && (
                  <Icon
                    InlineIcon={IconInfoSolid}
                    extraClasses={styles.infoIcon}
                  />
                )}
              </span>
            </DataTableCell>
            {row.monthlyValues.map((cell, i) => (
              <DataTableCell key={i} align="center">
                <ResultCellContent cell={cell} tooltipId={`na-${index}-${i}`} />
              </DataTableCell>
            ))}
            <DataTableCell align="center" divider="left">
              <ResultCellContent
                cell={row.total}
                tooltipId={`na-${index}-total`}
                tooltipPosition="left"
              />
            </DataTableCell>
          </DataTableRow>
        ))}
      </DataTable>
    </div>
  );
};

export default React.memo(CalculationResultsTable);
